import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { InstantSearch, Configure } from 'react-instantsearch';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import { ReviewSearchOptions, ReviewSearchBox } from '../utils';
const ReviewSearch = props => {
  const $ = _c(10);
  const t0 = props.searchQuery ? props.searchQuery : "";
  let t1;
  if ($[0] !== t0) {
    t1 = <Configure query={t0} hitsPerPage={5} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.onSearchUpdate) {
    t2 = <ReviewSearchBox onSearchUpdate={props.onSearchUpdate} />;
    $[2] = props.onSearchUpdate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = <ReviewSearchOptions {...props} />;
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="relative"><InstantSearch searchClient={searchClient} indexName="reviews">{t1}{t2}{t3}</InstantSearch></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
ReviewSearch.propTypes = {
  searchQuery: PropTypes.string,
  onSearchUpdate: PropTypes.func
};
export default ReviewSearch;